import { useCallback, useMemo } from 'react';
import { cn } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import { useCrossSell } from '@Queries/CrossSell';
import SkeletWave from '@Skelets/SkeletWave';
import styles from './CrossSell.module.css';

import type { HTMLAttributes, FC } from 'react';

interface CrossSellProps extends HTMLAttributes<HTMLDivElement> {
  productId: number;
}

const analyticsTitle = 'Сопутствующие товары карточка товара';

const CrossSell: FC<CrossSellProps> = (props) => {
  const { className, productId, ...restProps } = props;
  const { t } = useTranslation();
  const { data: crossSell = [], isPending, isError } = useCrossSell(productId);

  const categories = useMemo(() => {
    return crossSell?.map((category) => category.category).join(', ');
  }, [crossSell]);

  const handleClick = useCallback(() => {
    ModalWindows.open('CrossSell', { productId, analyticsTitle });
  }, [productId]);

  if (isPending) {
    return (
      <div {...restProps} className={cn(styles.skelet, className)}>
        <SkeletWave width='auto' />
      </div>
    );
  }

  if (isError) {
    return null;
  }

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.head} onClick={handleClick}>
        <div className={styles.icon} />
        <div className={styles.label}>{t('add-relative-products')}</div>
        {!!categories && <div className={styles.categories}>{categories}</div>}
      </div>
    </div>
  );
};

export default CrossSell;
